import axios from 'axios';
import { GET_ASSOCIATIONS, GET_ASSOCIATIONS_BY_USER, GET_ASSOCIATIONS_BY_CHARGE, EDIT_ASSOCIATION, ASSOCIATIONS_LOADING, CLEAR_ASSOCIATIONS } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IAssociation, ISociete } from '../../types/interfaces';
import store from '../store';

export const getAssociations = (duration: any, projectId: number | "ALL", projectName: string, possibleProjets: ISociete[]) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: ASSOCIATIONS_LOADING
  });
  axios
    .get('/api/associations', {...tokenConfig(getState), params: {duration, projectId, projectName, possibleProjets}})
    .then(res =>
      dispatch({
        type: GET_ASSOCIATIONS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getAssociationsByIdsPromise = async (ids: number[]) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/associations/byIds', {...tokenConfig(store.getState), params: {ids}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
    });
  });
};

export const getAssociationsByUser = (duration: any, userIds: number[], projectId: number, projectName: string, possibleProjets: ISociete[], titled: string = "ALL", byCommissionTo: number = 0) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: ASSOCIATIONS_LOADING
  });
  axios
    .get('/api/associations/byUser', {...tokenConfig(getState), params: {duration, userIds, projectId, projectName, possibleProjets, titled, byCommissionTo}})
    .then(res =>
      dispatch({
        type: GET_ASSOCIATIONS_BY_USER,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getAssociationsByCharge = (duration: any, userIds: number[], includeNocharges: number, titled: string, signeNotaireOnly: number, projectId: number, projectName: string, possibleProjets: ISociete[]) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: ASSOCIATIONS_LOADING
  });
  axios
    .get('/api/associations/byCharge', {...tokenConfig(getState), params: {duration, userIds, includeNocharges, titled, signeNotaireOnly, projectId, projectName, possibleProjets}})
    .then(res =>
      dispatch({
        type: GET_ASSOCIATIONS_BY_CHARGE,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getSummaryProjectAssociations = (duration: any, userIds: number[], includeNocharges: number, titled: string, possibleProjets: ISociete[]) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: ASSOCIATIONS_LOADING
  });
  axios
    .get('/api/associations/summaryProject', {...tokenConfig(getState), params: {duration, userIds, includeNocharges, titled, possibleProjets}})
    .then(res =>
      dispatch({
        type: GET_ASSOCIATIONS_BY_CHARGE,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getSummaryProjectAssociationsBudget0 = (titled: string) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: ASSOCIATIONS_LOADING
  });
  axios
    .get('/api/associations/summaryProjectBudget', {...tokenConfig(getState), params: {titled}})
    .then(res =>
      dispatch({
        type: GET_ASSOCIATIONS_BY_CHARGE,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getSummaryProjectAssociationsBudget = () => (dispatch: Function, getState: Function) => {
  dispatch({
    type: ASSOCIATIONS_LOADING
  });
  axios
    .get('/api/associations/summaryProjectBudget', {...tokenConfig(getState), params: {}})
    .then(res =>
      dispatch({
        type: GET_ASSOCIATIONS_BY_CHARGE,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getLivraisonsAForCommission = async (duration: any, userIds: number[], projectId: number, projectName: string, possibleProjets: ISociete[], titled: string = "ALL") : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/associations/livraisonForCommission', {...tokenConfig(store.getState), params: {duration, userIds, projectId, projectName, possibleProjets, titled}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getLivraisonsAForCommission", err)
    });
  });
};

export const editAssociation = (id: number, selectedFloor: any, selectedDivisionType: any, etage: string, type: string, position: string, percent: number, superficie: number, prixpart: number, comment: string, userId: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/associations/edit', {id, selectedFloor, selectedDivisionType, etage, type, position, percent, superficie, prixpart, comment, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_ASSOCIATION,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editComPartPromise = async (id: number, comId: number) : Promise<boolean> => {
  return new Promise((resolve) => {
    axios
      .post('/api/associations/editCom', {id,comId}, tokenConfig(store.getState))
      .then(res => {
        resolve(true)
      })
      .catch(err => {
        resolve(false);
        console.log("err editComPartPromise", err)
      });
  });
};

export const deleteAssociationPromise = async (id: number) : Promise<boolean> => {
  return new Promise((resolve) => {
    axios
      .delete(`/api/associations/${id}`, tokenConfig(store.getState))
      .then(res => {
        resolve(true)
      })
      .catch(err => {
        resolve(false);
        console.log("err deleteAssociationPromise", err)
      });
  });
};

export const clearAssociations = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_ASSOCIATIONS
  })
};